const TBusinessScreen = {
    // English
    "enUS": {
        'MY_BUSINESS': 'My Business',
        'NAME': 'Name',
        'COUNTRY': 'Country',
        'STATE': 'State',
        'CITY': 'City',
        'LOCATION': 'Address',
        'DESCRIPTION': 'Description (Optional)',
        'RESTAURANTS': 'Restaurants',
        'ADD_RESTAURANT': 'Add Restaurant',
        'EDIT': 'Edit',
        'CHANGE': 'Change',
        'ENABLED': 'Enabled',
        'DISABLED': 'Disabled',
        'MENU': 'Menu:',
        'SAVE': 'Save',
        'CANCEL': 'Cancel',
        'PHOTO': 'Photo',
        'LOGO': 'Logo',
    },
    // Spanish
    "esMX": {
        'MY_BUSINESS': 'Mi Negocio',
        'NAME': 'Nombre',
        'COUNTRY': 'País',
        'STATE': 'Estado',
        'CITY': 'Municipio',
        'LOCATION': 'Dirección',
        'DESCRIPTION': 'Descripción (Opcional)',
        'RESTAURANTS': 'Restaurantes',
        'ADD_RESTAURANT': 'Agregar Restaurante',
        'EDIT': 'Editar',
        'CHANGE': 'Cambiar',
        'ENABLED': 'Activo',
        'DISABLED': 'Inactivo',
        'MENU': 'Menú:',
        'SAVE': 'Guardar',
        'CANCEL': 'Cancelar',
        'PHOTO': 'Foto',
        'LOGO': 'Logo',
    }
}
export default TBusinessScreen;